import axios from "axios";
import { API_BASE_URL } from "../../config";

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("cms_token")}`,
  "Content-Type": "application/json",
});

export const fetchPlaceholders = async () => {
  const res = await axios.get(`${API_BASE_URL}/get-email-template-placeholder-list`, { headers: authHeaders() });
  if (res.data.status) return res.data.data || [];
  throw new Error(res.data.message || "Failed to fetch placeholders");
};

export const fetchAllTables = async () => {
  const res = await axios.get(`${API_BASE_URL}/get-all-tables`, { headers: authHeaders() });
  if (res.data.status) return res.data.data || [];
  throw new Error(res.data.message || "Failed to fetch tables");
};

export const fetchTableColumns = async (tableName) => {
  const res = await axios.get(`${API_BASE_URL}/get-table-columns`, {
    headers: authHeaders(),
    params: { table_name: tableName },
  });
  if (res.data.status) return res.data.data || [];
  throw new Error(res.data.message || "Failed to fetch columns");
};

export const addPlaceholder = async (payload) => {
  const res = await axios.post(`${API_BASE_URL}/add-email-template-placeholder`, payload, { headers: authHeaders() });
  if (res.data.status) return res.data.data;
  throw new Error(res.data.message || "Failed to add placeholder");
};

export const updatePlaceholder = async (id, payload) => {
  const res = await axios.put(`${API_BASE_URL}/update-email-template-placeholder/${id}`, payload, { headers: authHeaders() });
  if (res.data.status) return res.data.data;
  throw new Error(res.data.message || "Failed to update placeholder");
};

export const fetchTemplatePreview = async (templateId, leadId) => {
  const res = await axios.get(`${API_BASE_URL}/get-email-template-preview`, {
    headers: authHeaders(),
    params: { template_id: templateId, lead_id: leadId },
  });
  if (res.data.status) return res.data.data;
  throw new Error(res.data.message || "Failed to fetch template preview");
};
